<template>
  <section>
    <div>
      <template v-if="message === 'successful-activation'">
        <h5>{{ $t('pages.confirmation.account_title') }}</h5>
        <p>{{ $t('pages.confirmation.account_copy') }}</p>
        <p v-if="this.redirectionUrl">
          {{ $t('pages.confirmation.redirection_message') }}
        </p>
      </template>
      <template v-if="message === 'invalid-code'">
        <p v-html="$t('pages.confirmation.invalid_code')" />
      </template>
      <template v-if="message === 'expired-code'">
        <p v-html="$t('pages.confirmation.expired_code')" />
      </template>

      <rent-button @buttonclicked="redirectToHome">
        {{ $t('pages.confirmation.return') }}
      </rent-button>
    </div>
  </section>
</template>

<script>
import queryString from 'query-string'
import configureAxios from '../../utils/axiosConfig'
import RentButton from '../shared/RentButton'
import { removeSignupOrigin } from '../../utils/setLocalStorage'

export default {
  components: {
    RentButton,
  },
  methods: {
    redirectToHome() {
      window.location = '/'
    },
    geolid() {
      if (!window.gt) {
        return
      }
      /* eslint-disable */
      gt('sendLead', 'Création de compte', {
        'first_name':  'null',
        'last_name': 'null',
        'address':  'null',
        'email':  'null',
        'phone':  'null',
        'city':  'null',
        'zip_code':  'null'
      })
      /* eslint-enable */
    },
  },
  computed: {
    redirectionUrl() {
      const pageParams = queryString.parse(window.location.search)
      return pageParams && pageParams.redirect
    },
    message() {
      return window.renaultRent.message
    },
  },
  mounted() {
    removeSignupOrigin()
    if (this.window.renaultRent.message === 'successful-activation') {
      this.geolid()
      const token = window.renaultRent.access_token
      this.$store.commit('auth/SET_ACCESS_TOKEN', token)
    }

    configureAxios()
    if (this.redirectionUrl) {
      setTimeout(() => {
        window.location = this.redirectionUrl
      }, 5000)
    }
  },
}
</script>
<style lang="scss" scoped>

section {
  align-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 300px);
}

div {
  border: 1px solid $desert-storm;
  color: black;
  display: flex;
  flex-direction: column;
  max-width: 585px;
  padding: 15px;
  text-align: center;
  width: 100%;
}

h5 {
  font-family: $f-graphie-bold;
  margin: 0 0 10px;
}
</style>
